import { Field } from "@progress/kendo-react-form";
import type { KeyValue } from "@progress/kendo-react-form";
import { notEmptyDropDown, notEmptyValidator } from "@iliotech/data-wire";
import * as React from "react";
import { AutocompleteProps } from "../Autocomplete/Autocomplete";
import DropDownForForm from "../../DropDownForForm/DropDownForForm";
import { PositionCoupon } from "@iliotech/generated-api-v3";

interface IOwnProps extends Omit<AutocompleteProps, "name" | "label"> {
  errors: KeyValue<string>;
  name?: string;
  label?: string | null;
  allCoupons?: PositionCoupon[];
  onChange?: any;
}

export const CouponDateSearchField = ({
  errors,
  name = "expiryDate",
  label = "Expiry Date",
  defaultValue,
  allCoupons,
  onChange,
  ...rest
}: IOwnProps) => {
  const memoData = React.useMemo(() => [...(allCoupons ?? [])], [allCoupons]);
  if (!allCoupons) return null;

  return (
    <Field
      component={DropDownForForm}
      label={label}
      name={name}
      error={errors?.[name]}
      onChange={onChange}
      defaultValue={defaultValue}
      dataItemKey={"date"}
      textField={"date"}
      placeholder={"Enter Coupon Date"}
      validator={notEmptyDropDown}
      data={memoData}
    />
  );
};
